/*

  a n d r o i d  a r  l a u n c h
  AndroidARLaunch

  :description:
  A class to assist with launching into AR on Android devices.

*/

//
//  :code:
import {
  MESSAGE_GROUP_ANDROID, PLATFORM_ANDROID, SERVICE_AR_ASSISTANT, SERVICE_AR_MODELS, MODEL_CDN_BASE_URLS
} from "../statics";
import EyekandyARLaunch from "../_abstract/EyekandyARLaunch";

export default class AndroidARLaunch extends EyekandyARLaunch {

  constructor(options) {
    super(options)
    this.platform = PLATFORM_ANDROID
    this.group = MESSAGE_GROUP_ANDROID
  }


  //
  //  :api:
  //  Public API to be used by external callers.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  renderLaunchARURL(service, arid, environment, svOptions) {
    //
    //  Validate the inputs are valid before continuing.
    this._validateEnvironmentAndARIDAndService(environment, arid, service)
    //
    //  Return the SceneViewer URL.
    return this._renderAndroidSceneViewerIntentURL(service, arid, environment, svOptions)
  }

  renderModelURL(arid, environment) {
    //
    //  Validate the inputs.
    if (!environment) { environment = this.environment }
    this._validateEnvironmentAndARID(environment, arid)
    //
    //  Ok, render the URL for this model and return it.
    return `${MODEL_CDN_BASE_URLS[environment]}/GLB/${arid}.glb`
  }

  renderModelSoundURL(arid, environment) {
    if (!environment) { environment = this.environment }
    this._validateEnvironmentAndARID(environment, arid)
    //
    //  Ok, render the URL for this model and return it.
    return `${MODEL_CDN_BASE_URLS[environment]}/MP3/${arid}.mp3`
  }


  //
  //  :internal:
  //  Functions internal to the class, enums etc.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  _getARLaunchOptions() {
    return {
      mode: "ar_preferred",
      version: "1.1",
      resizable: false,
    }
  }

  _renderAndroidSceneViewerIntentURL(service, arid, environment, svOptions) {
    if (!svOptions) { svOptions = this._getARLaunchOptions() }
    //
    //  :step 1:
    //  Handle setting any dynamic values to our given options.
    if (!svOptions.resizable) {
      svOptions.resizable = service === SERVICE_AR_MODELS ? false : true
    }

    //
    //  :step 2:
    //  Define all of the pieces of our prefix/suffix strings.
    const pieces = {
      model: this.renderModelURL(arid, environment),
      sound: this.renderModelSoundURL(arid, environment),
      currentPage: window.location.href,
      fallbackUrl: this.render3DFWUrl(arid, environment)
    }

    //
    //  :step 3:
    //  Create an intent in two fragments, prefix and suffix, by assembling all of our fragments.
    const intent = {
      prefix: `intent://arvr.google.com/scene-viewer/${svOptions.version}?mode=${svOptions.mode}&resizable=${svOptions.resizable}`,
      suffix: `#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(pieces.fallbackUrl)};end;`
    }

    //
    //  :step 4:
    //  Assemble all of our fragments into a single URL for scene-viewer.
    const completeUrl = `${intent.prefix}&file=${encodeURIComponent(pieces.model)}${service === SERVICE_AR_ASSISTANT ? `&sound=${encodeURIComponent(pieces.sound)}` : ""
      }?link=${encodeURIComponent(pieces.currentPage)}&title=${intent.suffix}`

    //
    //  Return the URL to the caller.
    return completeUrl
  }

}
